import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import capitalize from 'lodash/capitalize';
export default { get: get, isEmpty: isEmpty, isEqual: isEqual, capitalize: capitalize };
//# sourceMappingURL=lodashUtils.js.map